import { render, staticRenderFns } from "./CommonTitle.vue?vue&type=template&id=7a6f460c&scoped=true"
import script from "./CommonTitle.vue?vue&type=script&lang=js"
export * from "./CommonTitle.vue?vue&type=script&lang=js"
import style0 from "./CommonTitle.vue?vue&type=style&index=0&id=7a6f460c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f460c",
  null
  
)

export default component.exports